import {
  IArke,
  SitePermissions,
  SiteResponseV1,
} from "@intreba/arke-api-client";
import i18n from "i18next";
import { observable, runInAction } from "mobx";
import BaseSettingsState from "../../BaseSettingsState";

export interface SitePictureSettingsResponseV1 {
  enabled: boolean;
  maxPictureCount: number;
  picturesRemovalDays: number;
}

export class PicturesState extends BaseSettingsState {
  private arke: IArke;

  constructor(t: i18n.TFunction, arke: IArke, site: SiteResponseV1) {
    super(
      t,
      "sitepicturesettings:read" as SitePermissions,
      site.permissions,
      site.siteId
    );
    this.arke = arke;
  }
  public async save(): Promise<void> {
    throw new Error("Method not implemented.");
  }
  public async retrieve(): Promise<void> {
    const settings = await this.arke.performGet<SitePictureSettingsResponseV1>(
      `/v1/sites/${this.siteId}/settings/pictures`
    );
    if (settings !== null) {
      runInAction(() => {
        this.enabled = settings.enabled;
        this.maxPictureCount = settings.maxPictureCount;
        this.picturesRemovalDays = settings.picturesRemovalDays;
      });
    }
  }
  @observable
  public enabled: boolean = false;
  @observable
  public maxPictureCount: number = 0;
  @observable
  public picturesRemovalDays: number = 0;
}
